// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js";
import { TerceraButton } from "./TerceraButton.js";
import { NotificationsCounterChangedEvent } from "../../Utils/Notifications/NotificationsCounterChangedEvent.js";
import { DataCache } from "../../Commons/DataCache.js";

export let NotificationsButton = TerceraButton.extend({
    tooltipKey: 'panel.Notifications.tt',
    isUnreadIDs: null
})

NotificationsButton.prototype.getType = function () { return 'NotificationsButton' };

NotificationsButton.prototype.oncomplete = function ()
{
    TerceraButton.prototype.oncomplete.apply(this);

    DataCache.OnBMCounterMsgReceived.Subscribe(this.OnBMCounterMsgReceived, this)

    this.localize()
}

NotificationsButton.prototype.dispose = function ()
{
    DataCache.OnBMCounterMsgReceived.UnSubscribe(this.OnBMCounterMsgReceived, this)

    TerceraButton.prototype.dispose.apply(this);
}

NotificationsButton.prototype.localize = function (bmID)
{
    this.set('tooltip', Resources.getResource(this.tooltipKey))
}

NotificationsButton.prototype.onReadMsg = function (bmID)
{
    if (this.isUnreadIDs[bmID])
    {
        this.isUnreadIDs[bmID] = false
        this.decrementCounter()
    }
}

NotificationsButton.prototype.OnBMCounterMsgReceived = function (bmIDs, action = NotificationsCounterChangedEvent.NewArr)
{
    if (!bmIDs)
        return

    if (action === NotificationsCounterChangedEvent.RemoveOne)  // only one BM id with RemoveOne action means that BM was read
    {
        this.onReadMsg(bmIDs)
        return
    }

    if (action === NotificationsCounterChangedEvent.AddOne)  // only one BM id with AddOne action means that new unread BM has come
    {
        if (this.isUnreadIDs && !this.isUnreadIDs[bmIDs])
        {
            this.isUnreadIDs[bmIDs] = true
            this.set('counter', (this.get('counter') || 0) + 1)
        }
        return
    }

    let result = {}, count = 0

    for (let i = 0; i < bmIDs.length; i++)
        if (!result[bmIDs[i]])
        {
            count++
            result[bmIDs[i]] = true
        }

    this.isUnreadIDs = result
    this.onCounterNumberChanged(count)
}

NotificationsButton.prototype.onCounterNumberChanged = function (unreadQty)
{
    if (unreadQty > 0)
        this.startCounterBlinking()

    this.set('counter', unreadQty)
}

NotificationsButton.prototype.decrementCounter = function ()
{
    let oldValue = this.get('counter')

    if (!oldValue)
        return   // can't be less than zero

    this.set('counter', oldValue - 1)
}